import { VirtualScrollerProps } from "../VirtualScroller/VirtualScroller";

export enum CarouselLoadingState {
  LOADING = "loading",
  ERROR = "error",
  LOADED = "loaded",
}

export interface WebGLCarouselRendererProps extends VirtualScrollerProps {
  /** The current loading state of the carousel */
  loadingState: CarouselLoadingState;
  /** The ID of the carousel */
  carouselID: string;
  /** The index of the carousel in the list */
  carouselIndex: number;
}
